module.exports = __webpack_public_path__ + "img/facebook_blue.5595dd61.svg";